export default {
    title: 'Jahr erstellen',
    createYear: 'Jahr erstellen',
    createAndEditYear: 'Erstellen und weiter bearbeiten',
    createYearSuccess: 'Das Jahr wurde erfolgreich erstellt.',
    createYearError: 'Das Jahr konnte nicht erstellt werden.'
}